import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography/Typography";

const styles = theme => ({
  envBanner: {
    background: "black",
    color: "white",
    textAlign: "center",
    textTransform: "uppercase",
    padding: theme.spacing(1)
  },
  envTitle: {
    "&::before, &::after": {
      content: '"/////"',
      marginRight: theme.spacing(0.5),
      letterSpacing: theme.spacing(0.25)
    },
    "&::before": {
      marginRight: theme.spacing(0.5)
    },
    "&::after": {
      marginLeft: theme.spacing(0.5)
    }
  },
  dev: {
    "&::before, &::after": {
      color: theme.palette.warning.main
    }
  },
  staging: {
    "&::before, &::after": {
      color: theme.palette.error.main
    }
  }
});

const OSSEnvBanner = ({ classes, environment }) => {
  let environmentTitle;

  switch (environment) {
    case "dev":
      environmentTitle = "Development Environment";
      break;
    case "staging":
      environmentTitle = "Staging Environment";
      break;
    default:
      environmentTitle = null;
      break;
  }

  return environmentTitle ? (
    <div className={classes.envBanner}>
      <Typography
        component="span"
        color="inherit"
        className={[classes.envTitle, classes[environment]].join(" ")}
      >
        {environmentTitle}
      </Typography>
    </div>
  ) : null;
};

export default withStyles(styles)(OSSEnvBanner);
